import React from 'react';
import styled from 'styled-components';
import { Tabs } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { CategoriesTab, CategoriesTabsProps } from './types';

const StyledTabs = styled(Tabs)`
    min-width: 520px;
`;

const CategoriesTabs = ({ activeTab, onChange }: CategoriesTabsProps) => {
    const { translate } = useTranslate();

    return (
        <StyledTabs data-testid="categories overview : tabs">
            <Tabs.Tab
                label={translate('pages.categories.tabs.templates')}
                isActive={activeTab === CategoriesTab.TEMPLATES}
                onClick={(e) => {
                    e.preventDefault();
                    onChange(CategoriesTab.TEMPLATES);
                }}
                data-testid="categories overview : templates tab"
            />
            <Tabs.Tab
                label={translate('pages.categories.tabs.categories')}
                isActive={activeTab === CategoriesTab.CATEGORIES}
                onClick={(e) => {
                    e.preventDefault();
                    onChange(CategoriesTab.CATEGORIES);
                }}
                data-testid="categories overview : categories tab"
            />
        </StyledTabs>
    );
};

export default CategoriesTabs;
